import { CreateExerciseDTO, ExerciseConfig, ExerciseConfigExecutionTypeEnum, UpdateExerciseDTO } from '@/generated';

type CreateOrUpdateExerciseDTO = CreateExerciseDTO | UpdateExerciseDTO;

enum ExerciseValidationErrors {
  ExerciseDifficultyNotSet = 'A difficulty for the exercise must be set',
  NoMainBodyZone = 'A primary Body Zone must be selected.',
  TitleMustNotBeEmpty = 'Title must not be empty',
  RepsMustLargerZero = 'Repetitions must be > 0',
}

export const validateExercise = (exercise: CreateOrUpdateExerciseDTO) => {
  let errors: Array<string> = [];

  if (exercise.config.executionType === ExerciseConfigExecutionTypeEnum.Reps && (exercise.config.value ?? 0) <= 0) {
    errors.push(ExerciseValidationErrors.RepsMustLargerZero);
  }
  if (!exercise.mainBodyZoneId) errors.push(ExerciseValidationErrors.NoMainBodyZone);
  if (!exercise.name.trim()) errors.push(ExerciseValidationErrors.TitleMustNotBeEmpty);
  if (!exercise.difficulty) errors.push(ExerciseValidationErrors.ExerciseDifficultyNotSet);

  return errors;
};

export const validateDeckExerciseConfig = (config: ExerciseConfig) => {
  let errors: Array<string> = [];

  if (config.executionType === ExerciseConfigExecutionTypeEnum.Reps && (config.value ?? 0) <= 0) {
    errors.push(ExerciseValidationErrors.RepsMustLargerZero);
  }

  return errors;
};
